import React, { useEffect } from "react";
import Close from "../Svg/Close";
import CircleCheckmark from "../Svg/CircleCheckmark";
import CircleDanger from "../Svg/CircleDanger";
import CircleExclamation from "../Svg/CircleExclamation";
import CircleInfo from "../Svg/CircleInfo";
import "./Toast.scss";

type ToastType = "success" | "error" | "warning" | "info";

interface ToastMessageProps {
  message: string | undefined;
  visible: boolean | undefined;
  duration?: number;
  type: ToastType | undefined | string;
  onClose: () => void;
}

const theme = [
  {
    id: "info",
    bg: "bg-cyan-500",
    text: "text-cyan-50",
    icon: <CircleInfo />,
  },
  {
    id: "warning",
    bg: "bg-yellow-500",
    text: "text-yellow-50",
    icon: <CircleExclamation />,
  },
  {
    id: "error",
    bg: "bg-red-500",
    text: "text-red-50",
    icon: <CircleDanger />,
  },
  {
    id: "success",
    bg: "bg-green-500",
    text: "text-green-50",
    icon: <CircleCheckmark />,
  },
];

const Toast: React.FC<ToastMessageProps> = ({
  message,
  visible,
  duration = 3000,
  type,
  onClose,
}) => {
  const themeSet = theme.find((x) => x.id === type);
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
  }, [visible, onClose, duration]);

  if (!visible) return null;

  return (
    <div
      data-testid="toast"
      className="fixed top-10 right-10 z-[9999] pointer-events-auto"
    >
      <div
        className={`flex relative items-center w-full min-w-64 max-w-96  p-4 text-white rounded-sm shadow-sm ${themeSet?.bg || ""}`}
      >
        <div className="flex-none items-center pt-1">{themeSet?.icon}</div>
        <div className="basis-lg grow font-semibold p-1">{message}</div>
        <div className="basis-lg flex-none items-center ms-auto p-1">
          <Close className="cursor-pointer" onClick={onClose} />
        </div>
      </div>
    </div>
  );
};

export default Toast;
